import {ProgressBarButton, ProgressBarButtonProps} from "../Common/Elements/ProgressBarButton";

import {useContext, useEffect, useRef, useState} from "react";
import {getUser, LOADED, LOADING, postClaimFriends} from "../../communication/communication";
import {renderTime} from "../../communication/format";
import {loaded, loading} from "../../communication/wrapped";
import {useConfig} from "../../communication/configuration";
import {useTranslation} from "react-i18next";
import {SetBalanceContext} from "../Common/Authorization/UserProvider";
import {WaUser} from "../../types/farming";


const loadingProps: ProgressBarButtonProps = {
    text: "Loading",
    progress: 0,
    onSuccessClick: () => {},
    onFailClick: () => {},
    backgroundColor: "#207bf9",
    textColor: "#ffffff",
}

export function ClaimFriendsButton({bonus, fetchFriends} : {bonus : number, fetchFriends : () => void}) {
    const [currentTime, setCurrentTime] = useState(new Date().getTime())
    const [lastPressed, setLastPressed] = useState(loading(0))
    const [isDone, setIsDone] = useState(false)
    const refreshTimer = useRef<NodeJS.Timer>()
    const {t} = useTranslation()

    const config = useConfig();
    const requiredTime = config.timing.minutes_to_next_friends_claim * 60 * 1000;

    const setBalance = useContext(SetBalanceContext)
    const [user, setUser] = useState(loading<WaUser>(null!));

    useEffect(() => {
        getUser().then(setUser);
    }, []);

    const refreshLastPressed = () => {
        const time = new Date().getTime()
        setLastPressed(loaded(time))
    }

    const updateTime = () => {
        setCurrentTime(new Date().getTime());
    }

    useEffect(() => {
        refreshTimer.current = setInterval(updateTime, 10);
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(fetchFriends, [isDone]);

    useEffect(() => {
        // Set lastPressed once
        if (user.statusCode !== LOADED) return;
        if (lastPressed.statusCode !== LOADING) return;
        const gotLastPressed = user.data?.last_friend_claim_ts
            ? user.data?.last_friend_claim_ts
            : 0;
        setLastPressed(loaded(gotLastPressed));
    }, [user, lastPressed]);

    const claimFriendsBonus = () => {
        postClaimFriends()
            .then(r => {if (r.statusCode !== LOADED) throw Error("Not loaded"); return r})
            .then(r => setBalance(r.data!))
            .then(_ => setIsDone(false))
            .catch(error => console.log(error));
        refreshLastPressed();
    }


    if (lastPressed.statusCode !== LOADED) {
        return (
            <div className="claim-bonus-button">
                <ProgressBarButton props={loadingProps}/>
            </div>
        )
    }

    const timeData = {
        h: t("____TimeHourMark"),
        m: t("____TimeMinuteMark"),
        s: t("____TimeSecondMark")
    }

    const progress = Math.min((currentTime - lastPressed.data!) / requiredTime, 1);
    const timeDiff = lastPressed.data! + requiredTime - currentTime;
    const text = progress < 1 ? renderTime(timeDiff, timeData) : `${bonus} Test Credits`

    // One time switch to done to reload contents
    if (progress >= 1 && !isDone) setIsDone(true);

    const doNothing = () => {};

    const props: ProgressBarButtonProps = {
        text: text,
        progress: bonus > 0 ? progress : 0,
        onSuccessClick: bonus > 0 ? claimFriendsBonus : doNothing,
        onFailClick: doNothing,
        backgroundColor: "var(--color-main)",
        textColor: bonus > 0 && progress >= 1 ? "#000000" : "#808080",
    }

    return (
        <div className="claim-bonus-button">
            <ProgressBarButton props={props}/>
        </div>
    )
}